<!--
// app/components/base/BaseBackdropLoading.vue
-->
<script setup lang="ts">
type Props = {
  active: boolean;
};

defineProps<Props>();
</script>

<template>
  <div
    v-if="active"
    class="absolute z-10 top-0 left-0 w-full h-full backdrop-blur-sm rounded-lg flex justify-center"
  >
    <base-spinner class="mt-12" :size="30"></base-spinner>
  </div>
</template>

<style scoped></style>
